import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const growthSystems = [
  {
    number: '01',
    title: 'Visibilité & Leads',
    outcome: 'Être trouvé et transformer les visites en demandes qualifiées.',
    modules: ['Site ou landing page', 'Fondations SEO', 'Tracking utile', 'Capture et réservation'],
    accent: 'bg-neon-orange',
  },
  {
    number: '02',
    title: 'Vente & Suivi',
    outcome: 'Centraliser les prospects et ne plus laisser une opportunité sans réponse.',
    modules: ['CRM et pipeline', 'Emails clients', 'Suivi des devis', 'Automatisations ciblées'],
    accent: 'bg-amber-300',
  },
  {
    number: '03',
    title: 'Croissance complète',
    outcome: 'Relier acquisition, conversion et pilotage dans une même feuille de route.',
    modules: ['Acquisition', 'Parcours de conversion', 'Tableau de bord', 'Optimisation continue'],
    accent: 'bg-white',
  },
];

const Services = () => (
  <section id="systemes" className="relative overflow-hidden bg-[#0b0f17] py-20 text-white sm:py-28">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,106,0,0.14),_transparent_36%)]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-neon-orange">Trois systèmes, une priorité</p>
          <h2 className="mt-5 text-3xl font-bold tracking-[-0.03em] sm:text-5xl">
            Choisissez un résultat, pas une liste de prestations.
          </h2>
        </div>
        <p className="max-w-2xl text-lg leading-8 text-gray-400 lg:justify-self-end">
          Le diagnostic détermine le bon point de départ. Le catalogue complet reste disponible,
          mais votre projet avance autour d’un objectif commercial clair.
        </p>
      </div>

      <div className="mt-14 grid gap-5 lg:grid-cols-3">
        {growthSystems.map((system, index) => (
          <motion.article
            key={system.number}
            initial={false}
            transition={{ duration: 0.45, delay: index * 0.08 }}
            className="group relative overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.045] p-7 transition hover:-translate-y-1 hover:border-neon-orange/40 hover:bg-white/[0.07]"
          >
            <div className={`mb-8 h-1 w-12 rounded-full ${system.accent}`} aria-hidden="true" />
            <div className="flex items-start justify-between gap-4">
              <h3 className="text-2xl font-bold tracking-[-0.02em]">{system.title}</h3>
              <span className="font-mono text-sm text-gray-500">{system.number}</span>
            </div>
            <p className="mt-5 min-h-[84px] leading-7 text-gray-300">{system.outcome}</p>
            <ul className="mt-7 space-y-3 border-t border-white/10 pt-6">
              {system.modules.map((module) => (
                <li key={module} className="flex items-center gap-3 text-sm text-gray-400">
                  <span className="h-1.5 w-1.5 rounded-full bg-neon-orange" aria-hidden="true" />
                  {module}
                </li>
              ))}
            </ul>
          </motion.article>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-start justify-between gap-6 rounded-[28px] border border-white/10 bg-white/[0.04] p-7 sm:flex-row sm:items-center">
        <div>
          <p className="font-bold">Vous ne savez pas lequel commencer ?</p>
          <p className="mt-2 text-sm text-gray-400">C’est précisément le rôle du diagnostic : isoler le chantier qui débloque le reste.</p>
        </div>
        <Link
          to="/reserver"
          className="inline-flex min-h-14 w-full shrink-0 items-center justify-center rounded-full bg-neon-orange px-7 py-4 font-bold text-gray-950 transition hover:-translate-y-0.5 hover:bg-orange-400 focus:outline-none focus:ring-4 focus:ring-neon-orange/30 sm:w-auto"
        >
          Demander mon diagnostic
        </Link>
      </div>
    </div>
  </section>
);

export default Services;
